import { render, staticRenderFns } from "./ProcedureForm.vue?vue&type=template&id=2e5d9d0a&"
import script from "./ProcedureForm.vue?vue&type=script&lang=js&"
export * from "./ProcedureForm.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports